/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SignaturePadType {
  Checkout = 'checkout',
  Checkin = 'checkin'
}
